import { postRequest } from "../Services/AxiosConfiguration";
import { API_BASE_URL, UPDATE_FOLDER_STATUS } from "../Utils/Config";
export const ActivateOrDeactivateFolder = (
  useCaseId: number,
  folderId: number,
  status: number
) => {
  const url = API_BASE_URL + UPDATE_FOLDER_STATUS;
  postRequest(
    url,
    {
      useCaseId: useCaseId,
      folderId: folderId,
      status: status,
    },
    {}
  )
    .then((response: any) => {
      if (response.status === 200 && response) {
        if (!response.data.success) {
          console.log(response.data.message, "folder status update message");
        } else {
          console.log("failure");
        }
      }
    })
    .catch((error: any) => {
      console.log(error);
    });
};
